import { useQuery } from "@tanstack/react-query";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { ICommonServiceProps } from "@api/types/globalService.types";

export const useGetAllPermissionsServices = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const allPermissionsService = useQuery({
    queryKey: [
      "permissions",
      page,
      per_page,
      debouncedQuery,
      ...cacheKeys,
      JSON.stringify(filters),
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: "/permissions",
        searchParams: {
          page,
          per_page,
          "filter[name]": debouncedQuery,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allPermissionsService },
    states: { setSearchQuery, searchQuery },
  };
};

export const useGetSinglePermissionsServices = ({
  selectedRoleId,
}: {
  selectedRoleId?: number;
}) => {
  const singleRoleService = useQuery({
    queryKey: ["role", selectedRoleId],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `/roles/${selectedRoleId}`,
      }),
    enabled: !!selectedRoleId,
  });
  return {
    services: { singleRoleService },
  };
};
